import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Characteristics from './Characteristics';

export const StyledCharacteristics = styled(Characteristics)`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    flex-wrap: nowrap;
    max-width: 100%;
    overflow: hidden;
    
    color: ${COLORS.TextHint};
    
    & > * {
        white-space: nowrap;
    }
    
    & :nth-child(2) {
        flex-basis: 12px;
        flex-grow: 1;
        flex-shrink: 0;
        line-height: 100%;
        border-bottom: .5px dashed ${COLORS.TextDisabled};
        margin: 0 2px;
    }
`;
